import type { Payment } from "../types/payment.types";
import { PaymentSourceType } from "../constants/payment.constants";

/** For PAYROLL_ITEM, the item itself has no code — fall back to its parent run's. */
export function resolvePaymentSourceCode(
  payment: Pick<Payment, "sourceType" | "source">,
): string | null {
  const source = payment.source as
    | { code?: string | null; payrollRun?: { code?: string | null } | null }
    | undefined;
  const code = source?.code?.trim() || source?.payrollRun?.code?.trim();
  return code || null;
}

/**
 * For PAYROLL_ITEM, `sourceId` is the item's own id — not a valid `/finance/payroll/:id` target.
 * Link to the parent run's id instead; other source types link by their own sourceId as-is.
 */
export function resolvePaymentSourceLinkId(
  payment: Pick<Payment, "sourceType" | "sourceId" | "source">,
): number | null {
  if (payment.sourceType === PaymentSourceType.PAYROLL_ITEM) {
    const source = payment.source as
      | { payrollRun?: { id?: number | null } | null }
      | undefined;
    return source?.payrollRun?.id ?? null;
  }
  return payment.sourceId;
}

/** The employee a money-out payment (EMPLOYEE_ADVANCE / PAYROLL_ITEM) was actually paid to. */
export function resolvePaymentPayeeName(
  payment: Pick<Payment, "payeeType" | "payee">,
): string | null {
  if (!payment.payeeType || !payment.payee) return null;
  const name = [payment.payee.firstName, payment.payee.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || payment.payee.email?.trim() || payment.payee.code?.trim() || null;
}
